if (!customElements.get('mobile-sticky-bar')) {
  customElements.define(
    'mobile-sticky-bar',

    class MobileStickyBar extends HTMLElement {
      constructor() {
        super();
        
        // 新增：用于检测地址栏变化
        this.lastWindowHeight = window.innerHeight;
        this.scrollThreshold = 10; // 滚动阈值，避免微小变化误判
        this.ignoreTopThreshold = 100; // 顶部区域阈值
        this.isAddressBarChanging = false;
        this.addressBarChangeTimeout = null;
      }

      connectedCallback() {
        document.body.classList.add('mobile-sticky-bar-enabled');
        this.lastScrollTop = window.scrollY;
        this.scrollHandler = FoxTheme.utils.debounce(this.onScrollHandler.bind(this), 10);
        this.init();
        
        // 新增：监听窗口大小变化（地址栏显示/隐藏会触发resize）
        window.addEventListener('resize', this.handleResize.bind(this));
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.scrollHandler);
        window.removeEventListener('resize', this.handleResize);
        if (this.addressBarChangeTimeout) {
          clearTimeout(this.addressBarChangeTimeout);
        }
      }

      init() {
        this.calculateHeight();
        window.addEventListener('scroll', this.scrollHandler, { passive: true });
      }

      calculateHeight() {
        requestAnimationFrame(() => {
          document.documentElement.style.setProperty('--mobile-sticky-bar-height', `${this.offsetHeight}px`);
        });
      }

      // 新增：处理窗口大小变化（地址栏显示/隐藏）
      handleResize() {
        const currentHeight = window.innerHeight;
        const heightDiff = Math.abs(currentHeight - this.lastWindowHeight);
        
        // 如果高度变化较大（通常是地址栏），标记为地址栏变化
        if (heightDiff > 50) {
          this.isAddressBarChanging = true;
          
          // 300ms后清除地址栏变化标记
          if (this.addressBarChangeTimeout) {
            clearTimeout(this.addressBarChangeTimeout);
          }
          this.addressBarChangeTimeout = setTimeout(() => {
            this.isAddressBarChanging = false;
          }, 300);
        }
        
        this.lastWindowHeight = currentHeight;
      }

      onScrollHandler() {
        const offsetTop = document.getElementById('mobileNavStatic')?.offsetTop || 0;
        const scrollTop = window.scrollY;
        const pointTouch = offsetTop - scrollTop - window.innerHeight;
        
        // 新增：检查是否为地址栏变化
        const isNearTop = scrollTop < this.ignoreTopThreshold;
        const scrollDelta = scrollTop - this.lastScrollTop;
        const isTinyScroll = Math.abs(scrollDelta) < this.scrollThreshold;

        requestAnimationFrame(() => {
          // 忽略地址栏变化导致的微小滚动
          if (this.isAddressBarChanging || (isNearTop && isTinyScroll)) {
            // 如果是地址栏变化，不更新方向，但更新lastScrollTop
            this.lastScrollTop = scrollTop;
            return;
          }

          // 使用阈值判断真实滚动方向
          if (scrollDelta > this.scrollThreshold) {
            this.scrollDirection = 'down';
          } else if (scrollDelta < -this.scrollThreshold) {
            this.scrollDirection = 'up';
          } else {
            // 滚动变化太小，保持原有方向
            return;
          }

          this.lastScrollTop = scrollTop;

          // 原有的显示/隐藏逻辑
          if (this.scrollDirection === 'down' && pointTouch > 0) {
            this.classList.remove('up');
            this.classList.add('down');
            document.body.classList.remove('mobile-sticky-bar-up');
            document.body.classList.add('mobile-sticky-bar-down');
          } else {
            this.classList.add('up');
            this.classList.remove('down');
            document.body.classList.remove('mobile-sticky-bar-down');
            document.body.classList.add('mobile-sticky-bar-up');
          }
        });
      }
    }
  );
}